export default {
    RED: '#DC2F23',
    GREEN: '#3ed483',
    GREY: 'var(--dentsu-color-n500)',
    YELLOW: 'var(--dentsu-color-y500)'
}